import React from "react";
import { useHistory } from "react-router";

const UKC_Nosework = (props) => {


const history=useHistory();
  return (
    <div className="UKC_Nosework row">
      <div className="col-md-6">
        <div className="form-group">
          <select
            onChange={(e) => props?.handleOnChangeInput(e)}
            className="form-control-select"
            name="dog"
            value={props?.fields?.dog}
            placeholder="Dog"
            required
          >
            <option value="" defaultValue disabled>
              Dog
            </option>
            {props?.dogList?.map((d) => {
              return <option value={d._id}>{d.name}</option>;
            })}
          </select>
        </div>

        {props?.fields?.dog !== "" ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="organization"
              value={props?.fields?.organization}
              className="form-control-select"
              placeholder="Organization"
              required
            >
              <option value="" defaultValue disabled>
                Club
              </option>
              {props?.orgList?.map((d) => {
                return <option value={d.name}>{d.name}</option>;
              })}
            </select>
          </div>
        ) : (
          ""
        )}

        {props?.fields?.organization !== "" ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="program"
              value={props?.fields?.program}
              className="form-control-select"
              placeholder="program"
              required
            >
              <option value="" defaultValue disabled>
                Event
              </option>
              {props?.programList?.map((pro) => {
                return <option value={pro.name}>{pro.name}</option>;
              })}
            </select>
          </div>
        ) : (
          ""
        )}

        {props?.levelList?.length > 0 && props?.fields?.program !== "" ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="level"
              value={props?.fields?.level}
              className="form-control-select"
              placeholder="Level"
              required
            >
              <option value="" defaultValue disabled>
                Level
              </option>
              {props?.levelList?.map((lvl) => {
                return <option value={lvl.name}>{lvl.name}</option>;
              })}
            </select>
          </div>
        ) : (
          <div></div>
        )}

        {props?.elementList?.length > 0 && props?.fields?.level !== "" ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="element"
              value={props?.fields?.element}
              className="form-control-select"
              placeholder="Element"
              required
            >
              <option value="" defaultValue disabled>
                Element
              </option>
              {props?.elementList?.map((ele) => {
                return <option value={ele.name}>{ele.name}</option>;
              })}
            </select>
          </div>
        ) : (
          ""
        )}

        {props?.placementList?.length > 0 && props?.fields?.element !== "" ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="placement"
              value={props?.fields?.placement}
              className="form-control-select"
              placeholder="Placement"
              required
            >
              <option value="" defaultValue disabled>
                Placement
              </option>
              {props?.placementList?.map((plc) => {
                return <option value={plc.name}>{plc.name}</option>;
              })}
            </select>
          </div>
        ) : (
          ""
        )}

        {props?.sectionList?.length > 0 && props?.fields?.element ? (
          <div className="form-group">
            <select
              onChange={(e) => props?.handleOnChangeInput(e)}
              name="section"
              value={props?.fields?.section}
              className="form-control-select"
              placeholder="Section"
              required
            >
              <option value="" defaultValue disabled>
                Section
              </option>
              {props?.sectionList?.map((sec) => {
                return <option value={sec.name}>{sec.name}</option>;
              })}
            </select>
          </div>
        ) : (
          ""
        )}
        {props.fields?.element !== "" ? (
          <>
            <div className="form-group">
              <input
                name="faults"
                placeholder="Faults"
                value={props?.fields?.faults}
                type="number"
                min="0"
                className="form-control-select"
                onChange={props?.handleOnChangeInput}
              />
            </div>

            <div className="form-group">
              <input
                name="date"
                placeholder="date*"
                value={props?.fields?.date}
                type="date"
                className="form-control-select"
                onChange={props?.handleOnChangeInput}
              />
            </div>
            <div className="form-group">
              <input
                name="time"
                placeholder="Time (seconds)*"
                value={props?.fields?.time}
                type="number"
                className="form-control-select"
                onChange={props?.handleOnChangeInput}
              />
            </div>
            <div className="form-group">
              <input
                name="judge"
                placeholder="Judge*"
                value={props?.fields?.judge}
                type="text"
                className="form-control-select"
                onChange={props?.handleOnChangeInput}
              />
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      <div
        className="col-md-6 "
        style={{ minHeight: "300px", position: "relative" }}
      >
        {props?.fields?.element !== "" ? (
          <>
            <div className="form-group">
              <textarea
                name="qDowell"
                placeholder="What did you do well?*"
                value={props?.fields?.qDowell}
                rows="5"
                type="text"
                className="form-control-select"
                onChange={props?.handleOnChangeInput}
              ></textarea>
            </div>
            <div className="form-group">
              <textarea
                name="qImproveOn"
                placeholder="What do you want to improve?*"
                value={props?.fields?.qImproveOn}
                type="text"
                rows="5"
                className="form-control-select mb-4"
                onChange={props?.handleOnChangeInput}
              ></textarea>
              {/* <hr/> */}
              <button type="submit" className="result-btn ">
                Save
              </button>
            </div>
          </>
        ) : (
          ""
        )}
      </div>
      <div className="col-md-12">
        <div></div>
      </div>
      <div className="col-md-6"></div>
      <div className="col-md-6">
        <button
          type="submit"
          className="result-btn-back"
          onClick={() => {
             history.push('/profile/results')
          }}
        >
          Cancel
        </button>

        <p className="mt-4">* Indicates optional field</p>
      </div>
    </div>
  );
};

export default UKC_Nosework;
